import store from 'base/reducer/store';
import { FetchingProjectItemsActionType, PersistProjectItemsActionType } from 'features/Persist/actionTypes';
import { getTenantId } from 'features/Tenant/tenantUtils';
import { TenantIsActiveDeltaRequest, ProjectOrganizationClient, ProjectIsActiveResponse } from 'services/tenantManagementService';
import { tryCatchJsonByAction } from 'utils/fetchUtils';

export const getProjectOrganizationsAction = (projectId: number) => {
	const tenantId = getTenantId()!;
	const client = new ProjectOrganizationClient();
	return client.getAllByProjectId(tenantId, projectId);
}

export const updateProjectOrganizationsAction = (projectId: number, model: TenantIsActiveDeltaRequest) => {
	const tenantId = getTenantId()!;
	const client = new ProjectOrganizationClient();
	return client.update(tenantId, projectId, model);
}

export const persistProjectOrganizationsAction = async (projectId: number) => {
	const state = store.getState();

	if (state.persistedProjectOrganization.projectMap[projectId]?.fetching) {
		return;
	}

	store.dispatch(setProjectOrganizationsFetchingAction(true, projectId));

	const bindedAction = getProjectOrganizationsAction.bind(null, projectId);
	const response = await tryCatchJsonByAction(bindedAction);

	if (response.success && response.items) {
		store.dispatch(setProjectOrganizationsAction(projectId, response.items || []));
	} else {
		store.dispatch(setProjectOrganizationsFetchingAction(false, projectId));
	}
}

// redux

export const PROJECT_ORGANIZATIONS_FETCHING = 'PROJECT_ORGANIZATIONS_FETCHING';
export const PROJECT_ORGANIZATIONS_SET = 'PROJECT_ORGANIZATIONS_SET';

const setProjectOrganizationsFetchingAction = (fetching: boolean, projectId: number): FetchingProjectItemsActionType => {
	return {
		type: PROJECT_ORGANIZATIONS_FETCHING,
		fetching,
		projectId
	}
}

const setProjectOrganizationsAction = (projectId: number, items: ProjectIsActiveResponse[]): PersistProjectItemsActionType<ProjectIsActiveResponse> => {
	return {
		type: PROJECT_ORGANIZATIONS_SET,
		items,
		projectId
	}
}
